// extracted by mini-css-extract-plugin
module.exports = {"Front":"Front_Front__3AH4P","Wrapper":"Front_Wrapper__78Riz"};